import apiUtil from "@/util/apiUtil";
import type {InsightCard} from "../insightCardModels";

const BASE_URL = "/api/BentoInsightsDemo";

/**
 * Live demo-insight cards composed server-side (real data + LLM-filled template).
 * Kept separate from the static `insightCardModels` seeds and from the Coach Insights API.
 * Resolves to `null` when the backend legitimately has no insight to show (an expected state).
 */
const bentoInsightsDemoAPI = {
    async getDemoInsight(
        insightId: string,
        businessUnitId: string,
        signal?: AbortSignal
    ): Promise<InsightCard | null> {
        const url = `${BASE_URL}/${insightId}/${businessUnitId}`;
        // A "no insight" response is 204 No Content, which apiUtil surfaces as a non-object
        // (the response `ok` boolean). Only a real card body is an object — treat anything else
        // as "no card to show".
        const result = await apiUtil.fetchData<InsightCard | boolean | null>(url, signal);
        return result && typeof result === "object" ? (result as InsightCard) : null;
    }
};

export default bentoInsightsDemoAPI;
